import { translationOrganizations_da_part1 } from "./translationOrganizations.da.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationOrganizations_da_part2 } from "./translationOrganizations.da.part2";
import { translationOrganizations_da_part3 } from "./translationOrganizations.da.part3";

export const translationOrganizations_da = defineTranslationTree({
  ...translationOrganizations_da_part1,
  ...translationOrganizations_da_part2,
  ...translationOrganizations_da_part3,
});
